import React from 'react';

export default function IconNoActive() {
  return (
    <svg
      width="65"
      height="65"
      viewBox="0 0 120 120"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20.5709 20.571C27.2846 13.8573 38.1697 13.8573 44.8834 20.571L59.9999 35.6875L75.1163 20.571C81.83 13.8573 92.7152 13.8573 99.4289 20.571C106.143 27.2847 106.143 38.1698 99.4289 44.8835L84.3124 60L99.4289 75.1164C106.143 81.8302 106.143 92.7153 99.4289 99.429C92.7151 106.143 81.8301 106.143 75.1163 99.429L59.9999 84.3125L44.8834 99.429C38.1697 106.143 27.2846 106.143 20.5709 99.429C13.8572 92.7153 13.8572 81.8302 20.5709 75.1165L35.6873 60L20.5709 44.8835C13.8572 38.1698 13.8572 27.2847 20.5709 20.571Z"
        fill="#FAE9E6"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M94.8832 40.3379L75.221 60L94.8832 79.6622C99.0864 83.8654 99.0864 90.6801 94.8832 94.8833C90.68 99.0865 83.8652 99.0865 79.662 94.8833L59.9999 75.2212L40.3377 94.8833C36.1345 99.0865 29.3198 99.0865 25.1166 94.8833C20.9134 90.6801 20.9134 83.8654 25.1166 79.6622L44.7787 60L25.1166 40.3379C20.9134 36.1347 20.9134 29.3199 25.1166 25.1167C29.3198 20.9135 36.1345 20.9135 40.3377 25.1167L59.9999 44.7788L79.662 25.1167C83.8652 20.9135 90.68 20.9135 94.8832 25.1167C99.0864 29.3199 99.0864 36.1347 94.8832 40.3379ZM59.9999 50.0821L82.3137 27.7684C85.0524 25.0296 89.4928 25.0296 92.2315 27.7684C94.9703 30.5071 94.9703 34.9475 92.2315 37.6862L69.9177 60L92.2315 82.3138C94.9703 85.0525 94.9703 89.4929 92.2315 92.2317C89.4928 94.9704 85.0524 94.9704 82.3137 92.2317L59.9999 69.9179L37.6861 92.2317C34.9473 94.9704 30.507 94.9704 27.7682 92.2317C25.0295 89.4929 25.0295 85.0525 27.7682 82.3138L50.082 60L27.7682 37.6862C25.0295 34.9475 25.0295 30.5071 27.7682 27.7683C30.507 25.0296 34.9473 25.0296 37.6861 27.7684L59.9999 50.0821Z"
        fill="#CC1B00"
      />
    </svg>
  );
}
